export const API_SERVER_WS = process.env.REACT_APP_API_SERVER_WS;
export const API_SERVER_WSS = process.env.REACT_APP_API_SERVER_WSS;
export const API_SERVER_WS_V2 = process.env.REACT_APP_API_SERVER_WS_V2;
export const GA_ID = process.env.REACT_APP_GA_ID;
export const API_LOYALTY = process.env.REACT_APP_API_LOYALTY;
// export const API_LOYALTY_WS = process.env.REACT_APP_API_LOYALTY_WS;

export const TOKEN_OCR = process.env.REACT_APP_TOKEN_OCR;
// export const LINK_UAT = process.env.REACT_APP_LINK_UAT;
export const LINK_DEV = process.env.REACT_APP_LINK_DEV;

export const RankCodeServer = {
  // member : rank thường - chưa xếp hạng
  // silver : rank bạc
  // silver plus : rank bạc(KH bên banca)
  // premierclubhsbc: khách hàng HSBC - chưa có đang đợi thiết kế thêm
  // gold: rank vàng
  // platinum : rank bạch kim
  // diamond: rank kim cương

  MEMBER: 'member',
  SILVER: 'silver',
  SILVERPLUS: 'silver plus',
  PREMIERCLUBHSBC: 'premierclubhsbc',
  GOLD: 'gold',
  PLATINUM: 'platinum',
  DIAMOND: 'diamond',
};

export const MERCHANT = {
  myBvl: '0',
  myViettel: '1',
  viettelStore: '2',
  viettelPost: '3',
  bvSmart: '4',
  momo: '5',
};

export const optionsFilter = [
  {
    value: '1',
    label: 'Điểm tăng dần',
  },
  {
    value: '0',
    label: 'Điểm giảm dần',
  },
];

export const provinceList = [
  { value: '', label: 'Toàn quốc' },
  { value: 'Hà Nội', label: 'Hà Nội' },
  { value: 'Hồ Chí Minh', label: 'Hồ Chí Minh' },
  { value: 'An Giang', label: 'An Giang' },
  { value: 'Bà Rịa - Vũng Tàu', label: 'Bà Rịa - Vũng Tàu' },
  { value: 'Bắc Cạn', label: 'Bắc Cạn' },
  { value: 'Bắc Giang', label: 'Bắc Giang' },
  { value: 'Bạc Liêu', label: 'Bạc Liêu' },
  { value: 'Bắc Ninh', label: 'Bắc Ninh' },
  { value: 'Bến Tre', label: 'Bến Tre' },
  { value: 'Biên Hoà', label: 'Biên Hoà' },
  { value: 'Bình Định', label: 'Bình Định' },
  { value: 'Bình Dương', label: 'Bình Dương' },
  { value: 'Bình Phước', label: 'Bình Phước' },
  { value: 'Bình Thuận', label: 'Bình Thuận' },
  { value: 'Buôn Mê Thuột', label: 'Buôn Mê Thuột' },
  { value: 'Cà Mau', label: 'Cà Mau' },
  { value: 'Cần Thơ', label: 'Cần Thơ' },
  { value: 'Cao Bằng', label: 'Cao Bằng' },
  { value: 'Đà Nẵng', label: 'Đà Nẵng' },
  { value: 'Đắk Lắk', label: 'Đắk Lắk' },
  { value: 'Đắk Nông', label: 'Đắk Nông' },
  { value: 'Điện Biên', label: 'Điện Biên' },
  { value: 'Đồng Nai', label: 'Đồng Nai' },
  { value: 'Đồng Tháp', label: 'Đồng Tháp' },
  { value: 'Gia Lai', label: 'Gia Lai' },
  { value: 'Hà Giang', label: 'Hà Giang' },
  { value: 'Hà Nam', label: 'Hà Nam' },
  { value: 'Hà Tĩnh', label: 'Hà Tĩnh' },
  { value: 'Hải Dương', label: 'Hải Dương' },
  { value: 'Hải Phòng', label: 'Hải Phòng' },
  { value: 'Hậu Giang', label: 'Hậu Giang' },
  { value: 'Hoà Bình', label: 'Hoà Bình' },
  { value: 'Hưng Yên', label: 'Hưng Yên' },
  { value: 'Khánh Hòa', label: 'Khánh Hòa' },
  { value: 'Kiên Giang', label: 'Kiên Giang' },
  { value: 'Kon Tum', label: 'Kon Tum' },
  { value: 'Lai Châu', label: 'Lai Châu' },
  { value: 'Lâm Đồng', label: 'Lâm Đồng' },
  { value: 'Lạng Sơn', label: 'Lạng Sơn' },
  { value: 'Lào Cai', label: 'Lào Cai' },
  { value: 'Long An', label: 'Long An' },
  { value: 'Nam Định', label: 'Nam Định' },
  { value: 'Nghệ An', label: 'Nghệ An' },
  { value: 'Nha Trang', label: 'Nha Trang' },
  { value: 'Ninh Bình', label: 'Ninh Bình' },
  { value: 'Ninh Thuận', label: 'Ninh Thuận' },
  { value: 'Phú Thọ', label: 'Phú Thọ' },
  { value: 'Phú Yên', label: 'Phú Yên' },
  { value: 'Pleiku', label: 'Pleiku' },
  { value: 'Quảng Bình', label: 'Quảng Bình' },
  { value: 'Quảng Nam', label: 'Quảng Nam' },
  { value: 'Quảng Ngãi', label: 'Quảng Ngãi' },
  { value: 'Quảng Ninh', label: 'Quảng Ninh' },
  { value: 'Quảng Trị', label: 'Quảng Trị' },
  { value: 'Sóc Trăng', label: 'Sóc Trăng' },
  { value: 'Sơn La', label: 'Sơn La' },
  { value: 'Tây Ninh', label: 'Tây Ninh' },
  { value: 'Thái Bình', label: 'Thái Bình' },
  { value: 'Thái Nguyên', label: 'Thái Nguyên' },
  { value: 'Thanh Hoá', label: 'Thanh Hoá' },
  { value: 'Thừa Thiên Huế', label: 'Thừa Thiên Huế' },
  { value: 'Tiền Giang', label: 'Tiền Giang' },
  { value: 'Trà Vinh', label: 'Trà Vinh' },
  { value: 'Tuyên Quang', label: 'Tuyên Quang' },
  { value: 'Vĩnh Long', label: 'Vĩnh Long' },
  { value: 'Vĩnh Phúc', label: 'Vĩnh Phúc' },
  { value: 'Vũng Tàu', label: 'Vũng Tàu' },
  { value: 'Yên Bái', label: 'Yên Bái' },
];


export const invalidChangeGiftType = {
  LACK_POINT: 'LACK_POINT',
  LACK_QUANTITY: 'LACK_QUANTITY',
};

export const KEY_MENU = {
  home: 'home',
  contract: 'contract',
  gift: 'gift',
  service: 'service',
  contact: 'contact',
  premiumPayment: '/pages/premium-payment',
  systemManager: 'systemManager',
  accountManager: 'accountManager',
};